module.exports = __webpack_public_path__ + "src/img/del.dc24e456.svg";